import { createContext, useContext } from "react";
import type { QueryKey } from "@tanstack/react-query";
import { auditKeys } from "@amber/access/ui";
import { profileKeys } from "./queries";

export interface ProfileInvalidation {
  readonly invalidate: readonly QueryKey[];
  readonly invalidateOnConflict: readonly QueryKey[];
}

const AFTER_PROFILE_CHANGE: ProfileInvalidation = {
  invalidate: [profileKeys.all, auditKeys.all],
  invalidateOnConflict: [profileKeys.all],
};

// Profile changes also move sources, items and attributions, whose caches belong to modules Profiles may not
// import; the app that composes the screens widens the set.
const ProfileInvalidationContext = createContext<ProfileInvalidation>(AFTER_PROFILE_CHANGE);

export const ProfileInvalidationProvider = ProfileInvalidationContext.Provider;

export function useProfileInvalidation(): ProfileInvalidation {
  return useContext(ProfileInvalidationContext);
}
